module.exports = __webpack_public_path__ + "static/img/register-img.53d3b9c2.png";